import { useOpenKeyboardShortcutsModal } from '#pplx/frontend/apps/ask/ask-input/ask-input-misc/hooks/useOpenKeyboardShortcutsModal.js';
import { useRegisterShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { useCallback } from 'react';
/**
 * Registers the **Show Shortcuts** global shortcut:
 *   - macOS: Cmd+/
 *   - Windows/Linux: Ctrl+/
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 *
 * Opens the helper modal on web or the editor modal on the Windows app.
 * The helper modal receives the full list of shortcut definitions from
 * the manifest so all shortcuts are discoverable regardless of whether
 * they are currently mounted.
 */
export function useShowShortcutsShortcut() {
    const openKeyboardShortcutsModal = useOpenKeyboardShortcutsModal();
    const handler = useCallback((e) => {
        // Prevent the browser default so the key combo doesn't trigger any
        // native behaviour (e.g. Ctrl+/ may toggle caret browsing in some browsers).
        e.preventDefault();
        openKeyboardShortcutsModal();
    }, [openKeyboardShortcutsModal]);
    useRegisterShortcut({ id: 'show-shortcuts', handler });
}
//# sourceMappingURL=useShowShortcutsShortcut.js.map